import { ArcherElement } from "react-archer";

export default function ProductRuleCard({obj, index, onEditRule, onDeleteRule}){ 
     switch(obj.keyString) {
          case 'languageAndChannel': return <LanguageAndChannelTile ruledata={obj} index={index} onEditRule={onEditRule}/>
          case 'stock': return <StockTile ruledata={obj} index={index} onEditRule={onEditRule} onDeleteRule={onDeleteRule}/>
          case 'product-attribute': return <ProductAttributeTile ruledata={obj} index={index} onEditRule={onEditRule} onDeleteRule={onDeleteRule}/>
          case 'rankingAndFilter': return <RankingAndFilterTile ruledata={obj} index={index} onEditRule={onEditRule} onDeleteRule={onDeleteRule}/>
          case 'productCategory': return <ProductCategoryTile ruledata={obj} index={index} onEditRule={onEditRule} onDeleteRule={onDeleteRule}/>
          default: return <h1>Error</h1>
     }
}

function LanguageAndChannelTile({ruledata, index, onEditRule}){
     return (
          <div className="card mb-2 shadow-sm position-relative" key={index}>
               <button type="button" className="card-header bg-light border-bottom py-1 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="d-flex align-items-center justify-content-center">
                         <i className="fas fa-globe me-2 text-primary"></i>
                         <h6 className="card-title mb-0 fw-bold">{ruledata.name}</h6>
                    </div>
               </button>
               <button type="button" className="card-body py-2 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="row g-1">
                         <div className="col-12 d-flex align-items-center">
                              <small className="text-dark fw-semibold">Sprache:</small>
                              <span className="ms-1 badge bg-light text-dark border">{ruledata?.language?.label || ruledata?.language}</span>
                         </div>
                         <div className="col-12 d-flex align-items-center">
                              <small className="text-dark fw-semibold">Kanal:</small>
                              <span className="ms-1 badge bg-light text-dark border">{ruledata?.channel?.label || ruledata?.channel}</span>
                         </div>
                    </div>
               </button>
          </div>
     ); 
}

function StockTile({ruledata, index, onEditRule, onDeleteRule}){
     const stockItems = [];
     if (ruledata.stock[0]) stockItems.push({label: "Rot", color: "danger"});
     if (ruledata.stock[1]) stockItems.push({label: "Grün", color: "success"});
     if (ruledata.stock[2]) stockItems.push({label: "Gelb", color: "warning"});
     
     return (
          <ArcherElement id={ruledata.id}>
               <div className="card mb-2 shadow-sm position-relative" key={index}>
                    <button type="button" className="card-header bg-light border-bottom py-1 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                         <div className="d-flex align-items-center justify-content-center">
                              <i className="fas fa-boxes me-2 text-success"></i>
                              <h6 className="card-title mb-0 fw-bold">{ruledata.name}</h6>
                         </div>
                    </button>
                    <button type="button" className="card-body py-2 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                         <div className="row g-1">
                              <div className="col-12">
                                   <div className="d-flex align-items-start flex-wrap">
                                        <small className="text-dark fw-semibold me-2">Verfügbarkeit:</small>
                                        <div className="d-flex flex-wrap">
                                             {stockItems.length > 0 ? stockItems.map((item) => (
                                                  <span key={item.label} className={`badge bg-${item.color} me-1 mb-1`} style={{fontSize: '0.7rem'}}>{item.label}</span>
                                             )) : <span className="badge bg-light text-dark border" style={{fontSize: '0.7rem'}}>Keine</span>}
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </button>
                    {onDeleteRule && (
                         <button
                              type="button"
                              className="pp-rule-delete-btn"
                              onClick={(e) => {
                                   e.stopPropagation();
                                   onDeleteRule(ruledata);
                              }}
                              title="Regel löschen"
                         >
                              <i className="fas fa-trash"></i>
                         </button>
                    )}
               </div>
          </ArcherElement>
     ); 
}

function ProductAttributeTile({ruledata, index, onEditRule, onDeleteRule}){

     const displayEquation = () => {
          if (!ruledata.equation) return "Keine Definition";
          if (Array.isArray(ruledata.equation)) {
               return ruledata.equation.join(" ");
          }
          return ruledata.equation;
     };

     return (
          <div className="card mb-2 shadow-sm position-relative" key={index}>
               <button type="button" className="card-header bg-light border-bottom py-1 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="d-flex align-items-center justify-content-center">
                         <i className="fas fa-tags me-2 text-warning"></i>
                         <h6 className="card-title mb-0 fw-bold">{ruledata.name}</h6>
                    </div>
               </button>
               <button type="button" className="card-body py-2 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="row g-1">
                         <div className="col-12">
                              <div className="d-flex align-items-start flex-wrap">
                                   <small className="text-dark fw-semibold me-2">Attribute:</small>
                                   <span className="badge bg-light text-dark border" style={{fontSize: '0.7rem', wordBreak: 'break-all'}}>
                                        { displayEquation() }
                                   </span>
                              </div>
                         </div>
                    </div>
               </button>
               {onDeleteRule && (
                    <button
                              type="button"
                              className="pp-rule-delete-btn"
                         onClick={(e) => {
                              e.stopPropagation();
                              onDeleteRule(ruledata);
                         }}
                         title="Regel löschen"
                    >
                         <i className="fas fa-trash"></i>
                    </button>
               )}
          </div>
     );
}

function RankingAndFilterTile({ruledata, index, onEditRule, onDeleteRule}){
     return (
          <div className="card mb-2 shadow-sm position-relative" key={index}>
               <button type="button" className="card-header bg-light border-bottom py-1 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="d-flex align-items-center justify-content-center">
                         <i className="fas fa-sort-amount-down me-2 text-info"></i>
                         <h6 className="card-title mb-0 fw-bold">{ruledata.name}</h6>
                    </div>
               </button>
               <button type="button" className="card-body py-2 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="row g-1">
                         {(ruledata.rankingFirst || ruledata.rankingSecond) && (
                              <div className="col-12">
                                   <div className="d-flex align-items-center flex-wrap">
                                        <small className="text-dark fw-semibold me-2">Ranking:</small>
                                        <div className="d-flex align-items-center">
                                             {ruledata.rankingFirst && <span className="badge bg-light text-dark border me-1" style={{fontSize: '0.7rem'}}>&gt; {ruledata.rankingFirst} €</span>}
                                             {ruledata.rankingSecond && <span className="badge bg-light text-dark border ms-1" style={{fontSize: '0.7rem'}}>&lt; {ruledata.rankingSecond} €</span>}
                                        </div>
                                   </div>
                              </div>
                         )}
                         {(ruledata.priceFirst || ruledata.priceSecond) && (
                              <div className="col-12">
                                   <div className="d-flex align-items-center flex-wrap">
                                        <small className="text-dark fw-semibold me-2">Preis:</small>
                                        <div className="d-flex align-items-center">
                                             {ruledata.priceFirst && <span className="badge bg-light text-dark border me-1" style={{fontSize: '0.7rem'}}>&gt; {ruledata.priceFirst } €</span>}
                                             {ruledata.priceSecond && <span className="badge bg-light text-dark border ms-1" style={{fontSize: '0.7rem'}}>&lt; {ruledata.priceSecond } €</span>}
                                        </div>
                                   </div>
                              </div>
                         )}
                    </div>
               </button>
               {onDeleteRule && (
                    <button
                              type="button"
                              className="pp-rule-delete-btn"
                         onClick={(e) => {
                              e.stopPropagation();
                              onDeleteRule(ruledata);
                         }}
                         title="Regel löschen"
                    >
                         <i className="fas fa-trash"></i>
                    </button>
               )}
          </div>
     ); 
}

function ProductCategoryTile({ruledata, index, onEditRule, onDeleteRule}){
     const formatValue = (val) => {
          if (val === null || val === undefined) return null;
          if (Array.isArray(val)) {
               const parts = val
                    .map((v) => {
                         if (v === null || v === undefined) return null;
                         if (typeof v === "string" || typeof v === "number") return String(v);
                         if (typeof v === "object") return v.label || v.name || v.value || null;
                         return null;
                    })
                    .filter(Boolean);
               return parts.length > 0 ? parts.join(", ") : null;
          }
          if (typeof val === "object") {
               return val.label || val.name || val.value || null;
          }
          return String(val);
     };

     const categoryItems = [
          { key: 'department', label: 'Abteilung', data: formatValue(ruledata?.department) },
          { key: 'area', label: 'Gebiet', data: formatValue(ruledata?.area) },
          { key: 'category', label: 'Kategorie', data: formatValue(ruledata?.category) },
          { key: 'article', label: 'Artikel', data: formatValue(ruledata?.article) },
          { key: 'provider', label: 'Hersteller', data: formatValue(ruledata?.provider) },
          { key: 'productNrList', label: 'ProduktNr.', data: formatValue(ruledata?.productNrList) }
     ].filter(item => item.data);

     return (
          <div className="card mb-2 shadow-sm position-relative" key={index}>
               <button type="button" className="card-header bg-light border-bottom py-1 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="d-flex align-items-center justify-content-center">
                         <i className="fas fa-sitemap me-2 text-secondary"></i>
                         <h6 className="card-title mb-0 fw-bold">{ruledata.name}</h6>
                    </div>
               </button>
               <button type="button" className="card-body py-2 px-2 pp-clickable-block" onClick={() => onEditRule?.(ruledata)}>
                    <div className="row g-1">
                         {categoryItems.map((item, i) => (
                              <div key={i} className="col-12">
                                   <div className="d-flex align-items-center">
                                        <small className="text-dark fw-semibold me-1" style={{minWidth: '65px', fontSize: '0.7rem'}}>{item.label}:</small>
                                        <span className="badge bg-light text-dark border text-truncate" style={{fontSize: '0.7rem', maxWidth: '120px'}} title={item.data}>
                                             {item.data}
                                        </span>
                                   </div>
                              </div>
                         ))}
                         {ruledata?.productNrList && (
                              <div className="col-12 mt-1 d-flex align-items-center">
                                   <small className="text-dark fw-semibold me-1" style={{minWidth: '65px', fontSize: '0.7rem'}}>ProduktNr.:</small>
                                   <span className={`ms-1 badge ${ruledata?.filterProductNr ? 'bg-success' : 'bg-warning text-dark'}`} style={{fontSize: '0.7rem'}}>
                                        {ruledata?.filterProductNr ? 'Einschließen' : 'Ausschließen'}
                                   </span>
                              </div>
                         )}
                    </div>
               </button>
               {onDeleteRule && (
                    <button
                              type="button"
                              className="pp-rule-delete-btn"
                         onClick={(e) => {
                              e.stopPropagation();
                              onDeleteRule(ruledata);
                         }}
                         title="Regel löschen"
                    >
                         <i className="fas fa-trash"></i>
                    </button>
               )}
          </div>
     ); 
}